<template>
 <v-dialog title="이메일 재전송" v-model="emailResendDialog" persistent max-width="400px">
    <v-row no-gutters align="center" justify="center">
      <v-card id="popStyle02">
        <v-card-text>
          <v-text-field class="inputH48_01" v-model="receiverName"
            label="이름"
            value= emailRty.receiverName
            outlined
            rows="2"
            no-resize
            ></v-text-field>
            <v-text-field class="inputH48_01" v-model="receiverEmail"
            label="이메일"
            value= emailRty.receiverEmail
            outlined
            rows="2"
            no-resize
            ></v-text-field>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text class="" v-on:click="emailRetry">확인</v-btn>
          <v-btn text v-on:click="emailResendDialog = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-row>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-dialog>
</template>
<script>

import { emailRetry } from '@/api/contract/contractDetail'

export default {
  name: 'passCheck',
  components: {
  },
  filters: {
  },
  props:{
    emailRty: {}
  },
  data () {
    return {
      emailResendDialog : false,
      emailResend:{
        receiverName: '',
        receiverEmail: '',
        ownerAddress: '',
        ctrStatus: '',
        ctrNo: ''
      },
      receiverName: '',
      receiverEmail: ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open () {
      this.emailResend.ownerAddress = this.emailRty.ownerAddress
      this.emailResend.ctrStatus = this.emailRty.ctrStatus
      this.emailResend.ctrNo = this.emailRty.ctrNo
      this.emailResendDialog = true
      this.receiverName = this.emailRty.receiverName
      this.receiverEmail = this.emailRty.receiverEmail
    },
    emailRetry () {
      this.$refs.loading.start('이메일 재전송 중입니다.')
      this.emailResend.receiverName = this.receiverName
      this.emailResend.receiverEmail = this.receiverEmail
      emailRetry(JSON.stringify({ emailResend: this.emailResend })).then(response => {
        this.$refs.loading.end()
        this.result = response.rdata.rcode
        this.emailResendDialog = false
        if(response.rdata.rcode === 20000) {
            this.$refs.confirm.open('alert', '이메일 재전송', '이메일 재전송에 성공하였습니다.')
        }else {
            this.$refs.confirm.open('alert', '이메일 재전송', '이메일 재전송에 실패하였습니다.')
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
